import moment from 'moment';

export function onlyMondays(val: string): boolean {
  return moment(val).get('day') === 1;
}

export default {
  onlyMondays,
};
